<template>
  <pbc-popup @close='$emit("cancel")'>
    <template>
      <div class="m-3 flex flex-col">
        <div class="m-3 flex flex-col">
          <slot />
        </div>
        <div class="flex flex-row justify-center">
          <pbc-button @click='$emit("cancel")'>
            <close class="mx-2" />
            Cancel
          </pbc-button>
          <pbc-button @click='$emit("ok")'>
            <check class="mx-2" />
            OK
          </pbc-button>
        </div>
      </div>
    </template>
  </pbc-popup>
</template>
<script>
import Close from '@icons/Close.vue';
import Check from '@icons/Check.vue';
import PbcPopup from '@ui/molecules/PbcPopup.vue';
export default {
  components:{
    PbcPopup,
    Close,
    Check
  }
}
</script>
